// Cart Abandonment Action Types
export const FETCH_CART_ABANDONMENTS_REQUEST = 'FETCH_CART_ABANDONMENTS_REQUEST';
export const FETCH_CART_ABANDONMENTS_SUCCESS = 'FETCH_CART_ABANDONMENTS_SUCCESS';
export const FETCH_CART_ABANDONMENTS_FAILURE = 'FETCH_CART_ABANDONMENTS_FAILURE';

export const SEND_CART_REMINDER_REQUEST = 'SEND_CART_REMINDER_REQUEST';
export const SEND_CART_REMINDER_SUCCESS = 'SEND_CART_REMINDER_SUCCESS';
export const SEND_CART_REMINDER_FAILURE = 'SEND_CART_REMINDER_FAILURE';